import LocalizedStrings from 'localized-strings';

// TODO(matt): Consider moving some of these strings into the shine-start-library.
// TODO(matt): Improve the translations for downloadFormSubtitle, downloadFormLink and uploadFormDragDrop
const commonDownloadFormSubtitleEn = 'Download and fill the document';
const commonDownloadFormLinkEn = 'Download the template';
const commonUploadFormDragDropEn =
  'Drag and drop to upload the filled document';
const commonDownloadFormDescriptionEn =
  'Complete it and make sure to include your signature and today’s date. Then drag and drop it in the box below.';
const commonDownloadFormSubtitleFr = 'Téléchargez et complétez le document';
const commonDownloadFormLinkFr = 'Téléchargez le modèle';
const commonUploadFormDragDropFr = 'Déposez votre document complété ici';
const commonDownloadFormDescriptionFr =
  'Complétez-le et n’oubliez pas de le signer et de le dater à la date d’aujourd’hui. Déposez-le ensuite ci-dessous.';

export default new LocalizedStrings({
  en: {
    ACCRE: {
      documentDescription:
        'We’ll review your application as soon as you send this document',
      downloadFormDescription: commonDownloadFormDescriptionEn,
      downloadFormLink: commonDownloadFormLinkEn,
      downloadFormSubtitle: commonDownloadFormSubtitleEn,
      uploadFormDragDrop: commonUploadFormDragDropEn,
    },
    BIKE_DELIVERY_STATEMENT: {
      documentDescription:
        'This document is requested by the Trade and Companies Register (RCS) to certify that you make deliveries by bicycle.',
      downloadFormDescription: commonDownloadFormDescriptionEn,
      downloadFormLink: commonDownloadFormLinkEn,
      downloadFormSubtitle: commonDownloadFormSubtitleEn,
      uploadFormDragDrop: commonUploadFormDragDropEn,
    },
    CELIBACY_STATEMENT: {
      documentDescription:
        'This document is required by the Chambre des métiers et de l’artisanat (CMA) to attest that you are not married.',
      downloadFormDescription: commonDownloadFormDescriptionEn,
      downloadFormLink: commonDownloadFormLinkEn,
      downloadFormSubtitle: commonDownloadFormSubtitleEn,
      uploadFormDragDrop: commonUploadFormDragDropEn,
    },

    COMPANY_CERTIFICATE_OF_RESIDENCE: {
      documentDescription:
        'We must send this document to your CFE to certify the address of your company’s head office.',
      uploadDescription:
        'This document must be signed by the domiciliation company and you. It must be less than 3 months old',
      uploadFormDragDrop: commonUploadFormDragDropEn,
    },

    ctaContinue: 'Continue',

    downloadFormSubtitleWrapper: '1 • {subtitle}',

    NO_CRIMINAL_CONVICTION_STATEMENT: {
      documentDescription:
        'This document is requested by the Trade and Companies Register (RCS) to certify that you don’t have a criminal record.',
      downloadFormDescription: commonDownloadFormDescriptionEn,
      downloadFormLink: commonDownloadFormLinkEn,
      downloadFormSubtitle: commonDownloadFormSubtitleEn,
      uploadFormDragDrop: commonUploadFormDragDropEn,
    },

    POWER_OF_ATTORNEY: {
      documentDescription:
        'This document allows us to create your company on your behalf. You can print it or write a copy by hand, then fill it and upload it here.',
      downloadFormDescription: commonDownloadFormDescriptionEn,
      downloadFormLink: commonDownloadFormLinkEn,
      downloadFormSubtitle: commonDownloadFormSubtitleEn,
      uploadFormDragDrop: commonUploadFormDragDropEn,
    },

    uploadFailureMessage:
      'Upload failed. Please check your connection and try again',
    // TODO(matt): Format the bold 'browse' in blue
    uploadFormBrowse: 'or **browse** to choose a file',
    uploadFormSubtitle: 'Upload the signed document',
    uploadFormSubtitleWrapper: '2 • {subtitle}',
  },
  fr: {
    ACCRE: {
      documentDescription:
        'Nous pourrons vérifier votre inscription dès que nous aurons reçu ce document.',
      downloadFormDescription: commonDownloadFormDescriptionFr,
      downloadFormLink: commonDownloadFormLinkFr,
      downloadFormSubtitle: commonDownloadFormSubtitleFr,
      uploadFormDragDrop: commonUploadFormDragDropFr,
    },
    BIKE_DELIVERY_STATEMENT: {
      documentDescription:
        'Ce document est demandé par le Registre du Commerce et des Sociétés pour attester que vous effectuez bien vos livraisons à vélo.',
      downloadFormDescription: commonDownloadFormDescriptionFr,
      downloadFormLink: commonDownloadFormLinkFr,
      downloadFormSubtitle: commonDownloadFormSubtitleFr,
      uploadFormDragDrop: commonUploadFormDragDropFr,
    },
    CELIBACY_STATEMENT: {
      documentDescription:
        'Ce document est requis par la Chambre des métiers et de l’artisanat (CMA) pour attester que vous n’êtes pas marié·e.',
      downloadFormDescription: commonDownloadFormDescriptionFr,
      downloadFormLink: commonDownloadFormLinkFr,
      downloadFormSubtitle: commonDownloadFormSubtitleFr,
      uploadFormDragDrop: commonUploadFormDragDropFr,
    },
    COMPANY_CERTIFICATE_OF_RESIDENCE: {
      documentDescription:
        'Nous devons envoyer ce document à votre CFE pour attester de l’adresse du siège social de votre entreprise.',
      uploadDescription:
        'Ce document doit être signé par vous et par l’entreprise qui vous héberge. Il doit dater de moins de 3 mois.',
      uploadFormDragDrop: commonUploadFormDragDropFr,
    },
    ctaContinue: 'Continuer',
    downloadFormSubtitleWrapper: '1 • {subtitle}',
    NO_CRIMINAL_CONVICTION_STATEMENT: {
      documentDescription:
        'Ce document est requis par le Registre du Commerce et des Sociétés afin d’attester que vous n’avez pas de casier judiciaire.',
      downloadFormDescription: commonDownloadFormDescriptionFr,
      downloadFormLink: commonDownloadFormLinkFr,
      downloadFormSubtitle: commonDownloadFormSubtitleFr,
      uploadFormDragDrop: commonUploadFormDragDropFr,
    },
    POWER_OF_ATTORNEY: {
      documentDescription:
        'Ce document nous autorise à créer votre entreprise pour vous. Vous pouvez l’imprimer ou en faire une copie manuscrite, puis le remplir et l’ajouter ici.',
      downloadFormDescription: commonDownloadFormDescriptionFr,
      downloadFormLink: commonDownloadFormLinkFr,
      downloadFormSubtitle: commonDownloadFormSubtitleFr,
      uploadFormDragDrop: commonUploadFormDragDropFr,
    },
    uploadFailureMessage:
      'Le téléchargement a échoué. Veuillez vérifier votre connexion et réessayer.',
    uploadFormBrowse:
      'ou **parcourez** vos documents au format PDF, JPG ou PNG',
    uploadFormSubtitle: 'Téléchargez l’attestation une fois signée',
    uploadFormSubtitleWrapper: '2 • {subtitle}',
  },
} as const);
